import React, { Component } from 'react';
import Proptypes from 'prop-types';
import * as Icon from 'react-cryptocoins';
import DefaultIcon from './crypto-logo.svg';

const toCamelCase = input => {
  return input.replace(/\w\S*/g, s => s.charAt(0) + s.slice(1).toLowerCase());
};

const style = {
  marginRight: '5px',
};

const defautIconStyle = {
  height: '24px',
  width: '24px',
  marginRight: '5px',
};

export default function CryptoIcon({ symbol }) {
  if (!Icon[toCamelCase(symbol)]) {
    return <DefaultIcon style={defautIconStyle} />;
  }
  const Custom = Icon[toCamelCase(symbol)];
  return <Custom style={style} />;
}

CryptoIcon.propTypes = {
  symbol: Proptypes.string,
};
